import { DecimalPipe } from '@angular/common';
import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserWorkingHoursService } from 'projects/Administration/src/app/business-services/user-working-hours.service';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { OccasionalShiftSaveViewModel } from '../../../business-entities/occasionalshift-save-view-model';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { UserLunchShiftModel, UserLunchShiftRequestModel, UserOpeningHoursViewModel } from '../../../business-entities/user-opening-view-model';

@Component({
  selector: 'app-edit-user-shift',
  templateUrl: './edit-user-shift.component.html',
  styleUrls: ['./edit-user-shift.component.css']
})
export class EditUserShiftComponent implements OnInit {

  @Input() userId: string;

  constructor(
    private decimalPipe: DecimalPipe,
    private userWorkingHoursService: UserWorkingHoursService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private activeModal: NgbActiveModal,
    // private userService: UserDataService,
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private cdrf: ChangeDetectorRef,
    private modalService: NgbModal,
  ) { }

  async ngOnInit() {
    this.addOccasionalShiftForm = this.formBuilder.group({
      occasionname: ['', [Validators.required]],
      startdate: ['', [Validators.required]],
      enddate: ['', [Validators.required]],
    });
    await this.getOccasionList();
    this.ChangeOccasion();
  }
  addOccasionalShiftForm: FormGroup;
  userWorkingHours: UserOpeningHoursViewModel[];
  allowedTimesForSlotFrom: string[][] = [];
  allowedTimesForSlotTo: string[][] = [];
  allTimeStamps: string[] = [];
  zeroTime = '00:00';
  startdate: string;
  enddate: string;
  OccasionList: OccasionalShiftSaveViewModel[] = [];
  SelectedRadioButton: any = 1;
  isDisable: boolean = false;
  isDatesDisable: boolean = false;
  isDelete: boolean = false;
  popupCloseResult = false;

  lunchShift: UserLunchShiftModel = {
    id: 0,
    startTime: '00:00',
    endTime: '00:00',
    startTimeBreak1: '00:00',
    endTimeBreak1: '00:00',
    startTimeBreak2: '00:00',
    endTimeBreak2: '00:00',
    startTimeDate: null,
    endTimeDate: null,
    break1StartTimeDate: null,
    break1EndTimeDate: null,
    break2StartTimeDate: null,
    break2EndTimeDate: null,
    lunchStartTime: { hour: 0, minute: 0 },
    lunchEndTime: { hour: 0, minute: 0 },
    break1StartTime: { hour: 0, minute: 0 },
    break1EndTime: { hour: 0, minute: 0 },
    break2StartTime: { hour: 0, minute: 0 },
    break2EndTime: { hour: 0, minute: 0 },
  };

  addLunchShift: UserLunchShiftRequestModel = {
    id: null,
    receptionUserId: null,
    startTimeDate: '00:00',
    endTimeDate: '00:00',
    break1StartTimeDate: '00:00',
    break1EndTimeDate: '00:00',
    break2StartTimeDate: '00:00',
    break2EndTimeDate: '00:00',
  };

  async getOccasionList() {
    this.cdrf.detectChanges();
    await this.userWorkingHoursService.getSpecialOccasionList(this.userId).then((response) => {
      this.OccasionList = response.responseObject;
      this.cdrf.detectChanges();
    })
  }

  ChangeOccasion() {
    this.cdrf.detectChanges();
    let SelectedInput = this.OccasionList.filter(x => x.rowId == this.SelectedRadioButton);
    this.startdate = (SelectedInput[0].startDate) ? Utility.GetFormattedDate(SelectedInput[0].startDate) : null;
    this.enddate = (SelectedInput[0].endDate) ? Utility.GetFormattedDate(SelectedInput[0].endDate) : null;
    this.addOccasionalShiftForm.patchValue({
      occasionname: SelectedInput[0].occasionName
    })
    this.isDisable = true;
    if (this.SelectedRadioButton == 1) {
      this.isDatesDisable = true;
      this.isDelete = false;
    }
    else {
      this.isDatesDisable = false;
      if (Utility.getDateStringToDate(this.startdate) > new Date()) {
        this.isDelete = true;
      }
      else {
        this.isDelete = false;
      }
    }
    this.cdrf.detectChanges();
    this.getAll();
  }

  OnClear() {
    this.startdate = null;
    this.enddate = null;
    this.addOccasionalShiftForm.patchValue({
      occasionname: '',
      startdate: null,
      enddate: null
    });
    this.isDisable = false;
    this.SelectedRadioButton = 0;
    this.isDatesDisable = false;
    this.isDelete = false;
  }

  OnDelete() {
    let occasionalShiftDeleteViewModel =
    {
      rowId: this.SelectedRadioButton,
      receptionUserId: this.userId
    }
    let modelHeadermsg = this.translate.instant("lblDeleteSpecialOccasion");
    let modelBodymsg = this.translate.instant("lblSureToDeleteSpecialOccasion");
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.spinner.show();
        this.userWorkingHoursService.deleteSpecialOccasion(occasionalShiftDeleteViewModel).then((response) => {
          if (response.responseCode === Constant.SuccessResponseCode) {
              let successMsg = this.translate.instant('lblSuccesfullyDeletedSpecialOccasion');
              this.toastr.success(successMsg);
              this.SelectedRadioButton = 1;
              this.getOccasionList();
              this.ChangeOccasion();
          }
          this.spinner.hide();
        });
      }
    });
  }
  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

  get cpf() {
    return this.addOccasionalShiftForm.controls;
  }

  async AddOccasionalShift() {
    this.cdrf.detectChanges();
    if (this.addOccasionalShiftForm.invalid) {
      return;
    }
    let endDate = Utility.ConvertLocalDateToUTCDate(Utility.getDateStringToDate(this.addOccasionalShiftForm.value.enddate))
    let startDate = Utility.ConvertLocalDateToUTCDate(Utility.getDateStringToDate(this.addOccasionalShiftForm.value.startdate))
    let occasionalShiftSaveViewModel =
    {
      rowId: this.SelectedRadioButton,
      occasionName: this.addOccasionalShiftForm.value.occasionname,
      startDate: startDate,
      endDate: endDate,
      receptionUserId: this.userId
    }
    if (this.validateDateTime(new Date(startDate), new Date(endDate))) {
      await this.userWorkingHoursService.addEditSpecialOccasion(occasionalShiftSaveViewModel).then(async (response) => {
        if (response.responseCode === Constant.SuccessResponseCode) {
          if (!response.responseObject.isSuccess) {
            let errorMsg = this.translate.instant('lblClashingDate');
            this.toastr.error(errorMsg);
          }
          else {
            if (this.SelectedRadioButton == 0) {
              this.toastr.success(this.translate.instant('lblUserShiftAddedSuccessfully'));
              await this.getOccasionList();
              this.SelectedRadioButton = parseInt(response?.responseObject?.retValue);
              this.ChangeOccasion();
            }

            else {
              let successMsg = this.translate.instant('lblUserShiftUpdatedSuccessfully');
              this.toastr.success(successMsg);
              this.getOccasionList();
            }
          }
        }
      });
    }
  }

  validateDateTime(startDate: Date, endDate: Date) {
    if (endDate < startDate) {
      this.toastr.error(Constant.DateRangeValidation);
      return false;
    }
    return true;
  }

  async getAll() {
    await this.getUserWorkingHours();
    await this.GetUserLunchShiftDetails();
    this.initializeAllTimeStamps();
    this.manageAllowedTimeStamps();
  }

  manageAllowedTimeStamps(): void {
    this.manageAllowedTimeStampsForSlotFromInput();
    this.manageAllowedTimeStampsForSlotToInput();
  }

  manageAllowedTimeStampsForSlotToInput(): void {
    this.userWorkingHours.forEach((workingHours, index) => {
      const openingTimeInHours = workingHours.openingTimeHrs;
      if (openingTimeInHours === this.zeroTime) {
        this.allowedTimesForSlotTo[index] = this.allTimeStamps;
      } else {
        this.setAllowedClosingTime(index, openingTimeInHours);
      }
    });
  }

  manageAllowedTimeStampsForSlotFromInput(): void {
    this.userWorkingHours.forEach((workingHours, index) => {
      const closingTimeInHours = workingHours.closingTimeHrs;
      if (closingTimeInHours === this.zeroTime) {
        this.allowedTimesForSlotFrom[index] = this.allTimeStamps;
      } else {
        this.setAllowedOpeningTime(index, closingTimeInHours);
      }
    });
  }

  onChangeOpeningHours(index: number, time: any): void {
    this.userWorkingHours[index].openingTimeHrs = (time.hour.toString().length === 1 ? ("0" + time.hour) : time.hour) + ":" + (time.minute.toString().length === 1 ? ("0" + time.minute) : time.minute) + ":" + (time.second.toString().length === 1 ? ("0" + time.second) : time.second);
    this.setAllowedClosingTime(index, this.userWorkingHours[index].openingTimeHrs);
    if (this.userWorkingHours[index].closingTimeHrs === this.zeroTime) {
      const openingTimeIndex = this.allTimeStamps.findIndex(x => x === this.userWorkingHours[index].openingTimeHrs);
      const minClosingTimeIndex = openingTimeIndex + 1;
      this.userWorkingHours[index].closingTimeHrs = this.allTimeStamps[minClosingTimeIndex];
    }
  }


  onChangeClosingHours(index: number, time: any): void {
    let timeValue = (time.hour.toString().length === 1 ? ("0" + time.hour) : time.hour) + ":" + (time.minute.toString().length === 1 ? ("0" + time.minute) : time.minute) + ":" + (time.second.toString().length === 1 ? ("0" + time.second) : time.second);
    this.userWorkingHours[index].closingTimeHrs = timeValue;
    this.setAllowedOpeningTime(index, timeValue);
  }

  setAllowedOpeningTime(index: number, closingTime: string): void {
    const closingTimeIndex = this.allTimeStamps.findIndex(x => x === closingTime);
    this.allowedTimesForSlotFrom[index] = closingTimeIndex > -1 ? this.allTimeStamps.slice(0, closingTimeIndex) : this.allTimeStamps.slice();
  }

  setAllowedClosingTime(index: number, openingTime: string): void {
    const openingTimeIndex = this.allTimeStamps.findIndex(x => x === openingTime);
    this.allowedTimesForSlotTo[index] = openingTimeIndex > -1 ? this.allTimeStamps.slice(openingTimeIndex + 1) : this.allTimeStamps.slice();
  }

  initializeAllTimeStamps(): void {
    const totalHoursInDay = 24;
    const totalMinsInHour = 60;
    const timeDifferenceInMins = 15;
    for (let i = 0; i < totalHoursInDay; i++) {
      for (let j = 0; j < totalMinsInHour; j += timeDifferenceInMins) {
        const time = `${this.decimalPipe.transform(i, '2.0-0')}:${this.decimalPipe.transform(j, '2.0-0')}`;
        this.allTimeStamps.push(time);
      }
    }
    this.userWorkingHours.forEach(() => {
      this.allowedTimesForSlotFrom.push(this.allTimeStamps.slice());
      this.allowedTimesForSlotTo.push(this.allTimeStamps.slice());
    })
  }

  onSaveChanges(isSaveAndClose): void {
    this.setDefaultSlotTimeWhenNotWorking();
    this.spinner.show();

    this.addLunchShift.id = this.lunchShift.id;
    this.addLunchShift.receptionUserId = this.userId;
    this.addLunchShift.startTimeDate = Utility.ConvertLocalTimeToDateTime(this.lunchShift.startTime);
    this.addLunchShift.endTimeDate = Utility.ConvertLocalTimeToDateTime(this.lunchShift.endTime);
    this.addLunchShift.break1StartTimeDate = Utility.ConvertLocalTimeToDateTime(this.lunchShift.startTimeBreak1);
    this.addLunchShift.break1EndTimeDate = Utility.ConvertLocalTimeToDateTime(this.lunchShift.endTimeBreak1);
    this.addLunchShift.break2StartTimeDate = Utility.ConvertLocalTimeToDateTime(this.lunchShift.startTimeBreak2);
    this.addLunchShift.break2EndTimeDate = Utility.ConvertLocalTimeToDateTime(this.lunchShift.endTimeBreak2);
    let shiftModel = JSON.parse(JSON.stringify(this.userWorkingHours));
    shiftModel.forEach(element => {
      let openingTime = element.openingTime.hour + ":" + element.openingTime.minute;
      let closingTime = element.closingTime.hour + ":" + element.closingTime.minute;
      element.openingTimeHrs = Utility.ConvertLocalTimeToDateTime(openingTime);
      element.closingTimeHrs = Utility.ConvertLocalTimeToDateTime(closingTime);
      element.occasionId = this.SelectedRadioButton;
      element.openingTime = null;
      element.closingTime = null;
      element.ReceptionUserId = this.userId;
    });
    let viewModel =
    {
      userOpeningHoursViewModel: shiftModel,
      userLunchShiftModel: this.addLunchShift,
    }
    this.userWorkingHoursService.updateUserWorkingHours(viewModel).then((response) => {
      let result = response.responseObject;
      if (result.isSuccess) {
        let successMessage = this.translate.instant('lblUserShiftUpdatedSuccessfully');
        this.toastr.success(successMessage);
      } else {
        if (result.retValue == fromEnums.ErrorCodes.UserBreak) {
          let errMsg = this.translate.instant('lblInvalidBreakTimings');
          this.toastr.error(errMsg);
        }
        else {
          let errMsg = this.translate.instant('lblDealerShouldBeWorking') + ' ' + this.userWorkingHours.filter(x => x.dayNumber == parseInt(result.retValue))[0].day;
          this.toastr.error(errMsg);
        }
      }
      this.getUserWorkingHours();
      this.spinner.hide();
      if (isSaveAndClose)
        this.activeModal.close({ success: true });

    });
  }

  setDefaultSlotTimeWhenNotWorking() {
    this.userWorkingHours.forEach(workingHours => {
      if (!workingHours.open) {
        workingHours.openingTimeHrs = this.zeroTime;
        workingHours.closingTimeHrs = this.zeroTime;
      }
    })
  }

  async getUserWorkingHours() {
    this.spinner.show();
    this.userWorkingHours = await this.userWorkingHoursService.getUserWorkingHoursDetails(this.userId, this.SelectedRadioButton);
    this.userWorkingHours.forEach(x => {
      x.openingTimeHrs = (x.openingTimeHrs) ? Utility.ConvertToTimeFormat(x.openingTimeHrs) : "00:00";
      x.closingTimeHrs = (x.closingTimeHrs) ? Utility.ConvertToTimeFormat(x.closingTimeHrs) : "00:00";
      let openHour = x.openingTimeHrs.split(":");
      let closeHour = x.closingTimeHrs.split(":");
      x.openingTime = { hour: +openHour[0], minute: +openHour[1] }
      x.closingTime = { hour: +closeHour[0], minute: +closeHour[1] }
    })
    this.spinner.hide();
  }

  async GetUserLunchShiftDetails() {
    this.spinner.show();
    await this.userWorkingHoursService.getUserLunchShiftDetails(this.userId).then(result => {
      if (result.responseCode === fromEnums.ErrorCodes.SuccessCode && result.responseObject.length > 0) {
        this.lunchShift = result.responseObject[0];
        this.lunchShift.startTime = this.lunchShift.startTimeDate ? Utility.ConvertToTimeFormat(this.lunchShift.startTimeDate) : "00:00";
        this.lunchShift.endTime = this.lunchShift.endTimeDate ? Utility.ConvertToTimeFormat(this.lunchShift.endTimeDate) : "00:00";
        this.lunchShift.startTimeBreak1 = this.lunchShift.break1StartTimeDate ? Utility.ConvertToTimeFormat(this.lunchShift.break1StartTimeDate) : "00:00";
        this.lunchShift.endTimeBreak1 = this.lunchShift.break1EndTimeDate ? Utility.ConvertToTimeFormat(this.lunchShift.break1EndTimeDate) : "00:00";
        this.lunchShift.startTimeBreak2 = this.lunchShift.break2StartTimeDate ? Utility.ConvertToTimeFormat(this.lunchShift.break2StartTimeDate) : "00:00";
        this.lunchShift.endTimeBreak2 = this.lunchShift.break2EndTimeDate ? Utility.ConvertToTimeFormat(this.lunchShift.break2EndTimeDate) : "00:00";

        let startTime = this.lunchShift.startTime.split(":");
        let endTime = this.lunchShift.endTime.split(":");
        let startTimeBreak1 = this.lunchShift.startTimeBreak1.split(":");
        let endTimeBreak1 = this.lunchShift.endTimeBreak1.split(":");
        let startTimeBreak2 = this.lunchShift.startTimeBreak2.split(":");
        let endTimeBreak2 = this.lunchShift.endTimeBreak2.split(":");
        this.lunchShift.lunchStartTime = { hour: +startTime[0], minute: +startTime[1] }
        this.lunchShift.lunchEndTime = { hour: +endTime[0], minute: +endTime[1] }
        this.lunchShift.break1StartTime = { hour: +startTimeBreak1[0], minute: +startTimeBreak1[1] }
        this.lunchShift.break1EndTime = { hour: +endTimeBreak1[0], minute: +endTimeBreak1[1] }
        this.lunchShift.break2StartTime = { hour: +startTimeBreak2[0], minute: +startTimeBreak2[1] }
        this.lunchShift.break2EndTime = { hour: +endTimeBreak2[0], minute: +endTimeBreak2[1] }

        this.spinner.hide();
      }
      if (result.responseObject.length === 0 && result.responseCode.toString() === fromEnums.ErrorCodes.InvalidIdCode) {
        let errorMessage = this.translate.instant("lblInvalidDealerId");
        this.toastr.error(errorMessage);
      }
      this.spinner.hide();
    },
      _error => {
        this.spinner.hide()
      });
  }

  getstartHours(value: any, _model: any) {
    this.lunchShift.startTime = (value.hour.toString().length === 1 ? ("0" + value.hour) : value.hour) + ":" + (value.minute.toString().length === 1 ? ("0" + value.minute) : value.minute);
  }

  getendHours(value: any, _model: any) {
    this.lunchShift.endTime = (value.hour.toString().length === 1 ? ("0" + value.hour) : value.hour) + ":" + (value.minute.toString().length === 1 ? ("0" + value.minute) : value.minute);
  }

  getstartHoursBreak1(value: any, _model: any) {
    this.lunchShift.startTimeBreak1 = (value.hour.toString().length === 1 ? ("0" + value.hour) : value.hour) + ":" + (value.minute.toString().length === 1 ? ("0" + value.minute) : value.minute);
  }

  getendHoursBreak1(value: any, _model: any) {
    this.lunchShift.endTimeBreak1 = (value.hour.toString().length === 1 ? ("0" + value.hour) : value.hour) + ":" + (value.minute.toString().length === 1 ? ("0" + value.minute) : value.minute);
  }

  getstartHoursBreak2(value: any, _model: any) {
    this.lunchShift.startTimeBreak2 = (value.hour.toString().length === 1 ? ("0" + value.hour) : value.hour) + ":" + (value.minute.toString().length === 1 ? ("0" + value.minute) : value.minute);
  }

  getendHoursBreak2(value: any, _model: any) {
    this.lunchShift.endTimeBreak2 = (value.hour.toString().length === 1 ? ("0" + value.hour) : value.hour) + ":" + (value.minute.toString().length === 1 ? ("0" + value.minute) : value.minute);
  }

  OnClose() {
    this.activeModal.close({ success: true });
  }
}
